import { getAccount, login, passLogin, sendCode } from '@/apis/login';
import { Col, Form, Input, Row, Tooltip } from 'antd';
import {
	MobileInput,
	IMobileInfo,
	IMobileRef,
	IPOMessage,
	AreaEnum,
	IPOButton,
	LangEnum,
} from '@hylaa-npm/ipod';
import { useEffect, useRef, useState } from 'react';
import { FormWrap } from './style';
import { setStorage } from '@/utils/storage';
import store from '@/redux/store';
import types from '@/redux/type';
import { PageTypeEnum } from '@/utils/enum';
import { getSetting } from '@/apis/setting';
import { clientList } from '@/apis/printer';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setLocalLangs } from '@/utils/lang';

export enum IShowType {
	LOGIN = 'LOGIN',
	FORGET = 'FORGET',
	RESET = 'RESET',
}
const Login = ({ showMember, pageChange, account }: ILogInProps) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const [isMember, setIsMember] = useState(false);
	const [isShowTime, setIsShowTime] = useState<boolean>(false);
	const [codeTime, setCodeTime] = useState<string>(t('system.getCode'));
	const ref = useRef<IMobileRef>();
	let internal: NodeJS.Timeout | null = null;
	useEffect(() => {
		setIsMember(showMember || false);
	}, [showMember]);

	useEffect(() => {
		if (isShowTime) {
			getCodeSerce();
		} else {
			clearInterval(internal as NodeJS.Timeout);
			setCodeTime(t('system.getCode'));
		}
		return () => clearInterval(internal as NodeJS.Timeout);
	}, [isShowTime]);
	const getCodeSerce = () => {
		let time = 60;
		internal = setInterval(() => {
			setCodeTime(time.toString() + '秒后获取');
			if (time <= 0) {
				setIsShowTime(false);
				setCodeTime(t('system.getCode'));
				clearInterval(internal as NodeJS.Timeout);
				handleSwitech();
			}
			time--;
		}, 1000);
	};
	const handleSwitech = () => {
		form.resetFields();
		setIsShowTime(false);
		clearInterval(internal as NodeJS.Timeout);
	};

	const handleGetCode = () => {
		let mobileRuest = ((ref.current as unknown) as {
			getValidateRes: () => { res: boolean; mobileInfo: IMobileInfo };
		}).getValidateRes();
		if (!mobileRuest.res) {
			IPOMessage.error(t('common.plCorrectPhone'));
			return;
		}
		sendCode({
			countryCode: mobileRuest.mobileInfo.areaCode,
			mobile: mobileRuest.mobileInfo.phoneNum,
			type: 'AUTH_LOGIN_VERIFICATION',
		}).then((res) => {
			setIsShowTime(true);
		});
	};
	const toLogin = async (values: ILoginForm) => {
		let mobileRuest = ((ref.current as unknown) as {
			getValidateRes: () => { res: boolean; mobileInfo: IMobileInfo };
		}).getValidateRes();
		if (!mobileRuest.res) {
			IPOMessage.error(t('common.plCorrectPhone'));
			return;
		}
		if (!isMember) {
			if (!values.password) {
				IPOMessage.error(t('system.plInputPassword'));
				return;
			}
		}
		if (!values.code) {
			IPOMessage.error(t('common.plCode'));
			return;
		}
		let account = mobileRuest.mobileInfo.areaCode + mobileRuest.mobileInfo.phoneNum;
		if (isMember) {
			login({
				account: {
					areaCode: mobileRuest.mobileInfo.areaCode,
					mobile: mobileRuest.mobileInfo.phoneNum,
				},
				secure: {
					smsCode: values.code,
				},
			})
				.then((res) => {
					setStorage(
						'memberAccount',
						{
							areaCode: mobileRuest.mobileInfo.areaCode,
							mobile: mobileRuest.mobileInfo.phoneNum,
						},
						'locale',
					);
					let req = res as {
						refreshToken: string;
						accessToken: string;
					};
					setToken(req.accessToken, req.refreshToken);
					store.dispatch({
						type: types.CHANGE_CURRENT_PAGE_TYPE,
						data: PageTypeEnum.USER_PAGE,
					});
					setAccountLang(account);
				})
				.catch((e) => {});
		} else {
			passLogin({
				areaCode: mobileRuest.mobileInfo.areaCode,
				mobile: mobileRuest.mobileInfo.phoneNum,
				code: values.code,
				password: values.password,
			}).then((res) => {
				setStorage(
					'adminAccount',
					{
						areaCode: mobileRuest.mobileInfo.areaCode,
						mobile: mobileRuest.mobileInfo.phoneNum,
					},
					'locale',
				);
				let req = res as {
					refreshToken: string;
					accessToken: string;
				};
				setToken(req.accessToken, req.refreshToken);
				store.dispatch({
					type: types.CHANGE_CURRENT_PAGE_TYPE,
					data: PageTypeEnum.MANEGE_PAGE,
				});

				clientList().then((res: unknown) => {
					const list: ISplitEnd[] = (res as { list: ISplitEnd[] }).list;
					dispatch({
						type: types.CHANGE_CLIENTS,
						data: list,
					});
				});
				setAccountLang(account);
			});
		}
	};
	//设置token 以及 登录状态
	const setToken = async (accessToken: string, refreshToken: string) => {
		try {
			setStorage('accessToken', accessToken, 'locale');
			setStorage('refreshToken', refreshToken, 'locale');
			// 获取登录的角色信息
			let res = (await getAccount()) as IUserInfo & {
				initRecord?: {
					initStep: number;
				};
			};
			if (res.id) {
				store.dispatch({
					type: types.CHANGE_USERINFO,
					data: res,
				});
				store.dispatch({
					type: types.CHANGE_LOGIN_STATUS,
					data: true,
				});
			}
			if (res.initRecord) {
				if (res.initRecord.initStep === 0) {
					store.dispatch({
						type: types.CHANGE_USERINIT,
						data: true,
					});
				}
			}
		} catch {}
	};
	const setAccountLang = async (account: string) => {
		let langRes = (await getSetting()) as { key: 'Language'; value: LangEnum }[];
		if (langRes.length > 0) {
			let lang = LangEnum.ZH;
			langRes.some((item) => {
				if (item.key === 'Language') {
					lang = item.value;
					return true;
				}
			});
			setLocalLangs(account, lang);
		}
	};
	// 后台登录
	const getBackgroundLoginEl = () => {
		return (
			<FormWrap>
				<div className="form-title">{t('system.loginTitle')}</div>
				<Form form={form} colon={false} labelCol={{ span: 5, offset: 0 }} onFinish={toLogin}>
					<Form.Item label={t('system.account')}>
						{account && (
							<Tooltip title="请选择常用的国家/地区" mouseEnterDelay={3} mouseLeaveDelay={0.5}>
								<MobileInput
									key={JSON.stringify(account)}
									mobileRef={ref}
									defaultArea={AreaEnum.HK}
									mobileInfo={{ areaCode: account.areaCode, phoneNum: account.mobile }}
								/>
							</Tooltip>
						)}
					</Form.Item>
					{!isMember && (
						<Form.Item label={t('system.password')} name="password">
							<div className="form-item">
								<Input placeholder={t('system.plInputPassword')} type={'password'} />
							</div>
						</Form.Item>
					)}
					<Form.Item label={t('system.verifiCode')} name="code">
						<div className="form-item">
							<Input placeholder={t('system.plPhoneCode')} />
							<Tooltip
								title="点击这个按钮，您的手机将会收到一个带有验证码的短信， 您输入正确的验证码即可登录。"
								mouseEnterDelay={3}
								mouseLeaveDelay={0.5}>
								<IPOButton
									type="primary"
									className="form-getcode"
									onClick={handleGetCode}
									disabled={isShowTime}>
									{codeTime}
								</IPOButton>
							</Tooltip>
						</div>
					</Form.Item>
					{isMember && (
						<Row className="form-tip">
							<Col span={5}></Col>
							<Col span={19}>提示：未注册的手机号验证后将自动创建账号</Col>
						</Row>
					)}
					<Row className="form-btns">
						<Col span={5}></Col>
						<Col span={19}>
							<Tooltip title="点击进行登录进入系统" mouseEnterDelay={3} mouseLeaveDelay={0.5}>
								<IPOButton type="primary" htmlType="submit">
									{t('system.login')}
								</IPOButton>
							</Tooltip>
							{!isMember && (
								<IPOButton type="link" onClick={() => pageChange(IShowType.FORGET)}>
									{t('system.forgetPassword')}
								</IPOButton>
							)}
						</Col>
					</Row>
				</Form>
			</FormWrap>
		);
	};
	return <div>{getBackgroundLoginEl()}</div>;
};

export default Login;
